"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalRelativePositionApi = exports.VerticalAbsolutePositionApi = exports.VerticalAlignedPositionApi = exports.HorizontalRelativePositionApi = exports.HorizontalAbsolutePositionApi = exports.HorizontalAlignedPositionApi = void 0;
var image_enums_1 = require("./image-enums");
var HorizontalAlignedPositionApi = (function () {
    function HorizontalAlignedPositionApi(relativeTo, alignment) {
        this.type = image_enums_1.FloatingObjectHorizontalPositionTypeApi.Aligned;
        this.relativeTo = relativeTo;
        this.alignment = alignment;
    }
    return HorizontalAlignedPositionApi;
}());
exports.HorizontalAlignedPositionApi = HorizontalAlignedPositionApi;
var HorizontalAbsolutePositionApi = (function () {
    function HorizontalAbsolutePositionApi(relativeTo, position) {
        this.type = image_enums_1.FloatingObjectHorizontalPositionTypeApi.Absolute;
        this.relativeTo = relativeTo;
        this.position = position;
    }
    return HorizontalAbsolutePositionApi;
}());
exports.HorizontalAbsolutePositionApi = HorizontalAbsolutePositionApi;
var HorizontalRelativePositionApi = (function () {
    function HorizontalRelativePositionApi(relativeTo, relativePosition) {
        this.type = image_enums_1.FloatingObjectHorizontalPositionTypeApi.Relative;
        this.relativeTo = relativeTo;
        this.relativePosition = relativePosition;
    }
    return HorizontalRelativePositionApi;
}());
exports.HorizontalRelativePositionApi = HorizontalRelativePositionApi;
var VerticalAlignedPositionApi = (function () {
    function VerticalAlignedPositionApi(relativeTo, alignment) {
        this.type = image_enums_1.FloatingObjectVerticalPositionTypeApi.Aligned;
        this.relativeTo = relativeTo;
        this.alignment = alignment;
    }
    return VerticalAlignedPositionApi;
}());
exports.VerticalAlignedPositionApi = VerticalAlignedPositionApi;
var VerticalAbsolutePositionApi = (function () {
    function VerticalAbsolutePositionApi(relativeTo, position) {
        this.type = image_enums_1.FloatingObjectVerticalPositionTypeApi.Absolute;
        this.relativeTo = relativeTo;
        this.position = position;
    }
    return VerticalAbsolutePositionApi;
}());
exports.VerticalAbsolutePositionApi = VerticalAbsolutePositionApi;
var VerticalRelativePositionApi = (function () {
    function VerticalRelativePositionApi(relativeTo, relativePosition) {
        this.type = image_enums_1.FloatingObjectVerticalPositionTypeApi.Relative;
        this.relativeTo = relativeTo;
        this.relativePosition = relativePosition;
    }
    return VerticalRelativePositionApi;
}());
exports.VerticalRelativePositionApi = VerticalRelativePositionApi;
